import React, { useState, useEffect, useRef } from 'react'
import { Form, Button } from 'react-bootstrap'
import Layout from '../Layout/Layout.js';
import DataTable from 'react-data-table-component';
import { APIUrl } from '../../Helper/APIUrl.js';
import { SnackbarProvider, useSnackbar } from "notistack";
import { data } from 'autoprefixer';

function ManageAllProperties() {
    const Token = JSON.parse(localStorage.getItem('tcn'));
    const UserId = JSON.parse(localStorage.getItem('userid'));

    const { enqueueSnackbar } = useSnackbar();

    const [val, setVal] = useState(0);

    const [search, setsearch] = useState("");
    const [FilterDropdown, setFilterDropdown] = useState("");
    const [lstProperties, setlstProperties] = useState([]);
    const [filterlstProperties, setfilterlstProperties] = useState([]);

    //Use Ref for Focus
    const AllowedPostCountRef = useRef(null);
    const SubscriptionExpiryDateRef = useRef(null);

    //Insert and Update UseStates

    const [Username, setUsername] = useState("");
    const [Email, setEmail] = useState("");
    const [Phone, setPhone] = useState("");
    const [SubscriptionId, setSubscriptionId] = useState("");
    const [AllowedPostCount, setAllowedPostCount] = useState("");
    const [SubscriptionExpiryDate, setSubscriptionExpiryDate] = useState("");
    const [metaEdit, setMetaEdit] = useState(false);
    const [metaLoading, setMetaLoading] = useState(false);
    const [selectedMetaPropertyId, setSelectedMetaPropertyId] = useState(0);
    const [metaTitle, setMetaTitle] = useState("");
    const [metaDescription, setMetaDescription] = useState("");
    const [metaKeyword, setMetaKeyword] = useState("");
    const metaEditSectionRef = useRef(null);

    // Edit URL states
    const [urlEdit, setUrlEdit] = useState(false);
    const [urlLoading, setUrlLoading] = useState(false);
    const [selectedURLPropertyId, setSelectedURLPropertyId] = useState(0);
    const [autoGeneratedURL, setAutoGeneratedURL] = useState("");
    const [selectedURLRow, setSelectedURLRow] = useState(null);
    const urlEditSectionRef = useRef(null);

    const generateSlug = (text) => {
        if (!text) return "";
        // Trim, replace non-alphanumeric with space, collapse spaces/hyphens, then replace with single hyphen
        return text
            .toString()
            .trim()
            .toLowerCase()
            .replace(/[^a-z0-9\s-]/g, '')
            .replace(/[\s_-]+/g, '-')
            .replace(/^-+|-+$/g, '');
    }


    const [IsActive, setisactive] = useState(true);
    const [CreatedBy, setCreatedBy] = useState(UserId);
    const [CreatedOn, setCreatedOn] = useState("");
    const [ModifiedBy, setModifiedBy] = useState(UserId);
    const [ModifiedOn, setModifiedOn] = useState("");

    //Edit Populates States
    const [edit, setEdit] = useState(false);
    const [returnId, setreturnId] = useState(0);

    //API : Base Url + Controller Name
    const ConcateURL = APIUrl.NewProperty;



    function doEmptyStates() {
        setAllowedPostCount("");
        setSubscriptionExpiryDate("");
        setEdit(false)
    }

    function resetMetaStates() {
        setMetaEdit(false);
        setSelectedMetaPropertyId(0);
        setMetaTitle("");
        setMetaDescription("");
        setMetaKeyword("");
    }





    const parseJSON = async (response) => {
        try {
            if (response.status === 204 || response.status === 205) return null;
            const text = await response.text();
            if (!text) return null;
            return JSON.parse(text);
        }
        catch (err) {
            console.warn('Failed to parse JSON response', err);
            return null;
        }
    }

    const getAllProperties = async () => {
        try {
            const response = await fetch(ConcateURL + 'GetAllNewProperty', {
                method: "Post",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify({})
            });
            const result = await parseJSON(response);
            if (result?.data != null) {
                setlstProperties(result.data);
                setlstProperties(result.data.sort((a, b) => b.PropertyId - a.PropertyId));
                setfilterlstProperties(result.data.sort((a, b) => b.PropertyId - a.PropertyId));
                console.log(result.data);
            }
        }
        catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getAllProperties();
    }, []);


    const fnFeatureProperty = async (PropertyId) => {
        try {
            debugger
            const response = await fetch(ConcateURL + 'FeatureNewPropertybyAdmin', {
                method: "Post",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify({
                    PropertyId: PropertyId,
                    IsFeatured: true,
                    ModifiedBy: UserId
                })
            });
            const result = await parseJSON(response);
            if (result?.Message == "Success") {
                enqueueSnackbar("Property Featured Successfully", { variant: 'success' });
                getAllProperties();
            }
            else {
                enqueueSnackbar("Failed to feature property.", { variant: 'error' });
            }
        }
        catch (error) {
            console.log(error);
            enqueueSnackbar("An error occurred while processing your request.", { variant: 'error' });
        }
    };

    const openMetaEditor = (row) => {
        setSelectedMetaPropertyId(row.PropertyId || 0);
        setMetaTitle(row.MetaTitle || "");
        setMetaDescription(row.MetaDescription || "");
        setMetaKeyword(row.MetaKeyword || "");
        setMetaEdit(true);
        setTimeout(() => {
            metaEditSectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 0);
    };

    const openUrlEditor = (row) => {
        setSelectedURLPropertyId(row.PropertyId || 0);
        setAutoGeneratedURL(row.AutoGeneratedURL || "");
        setSelectedURLRow(row || null);
        setUrlEdit(true);
        setTimeout(() => {
            // Scroll to top and bring the URL edit section into view
            try {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            } catch (e) { }
            urlEditSectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 0);
    };

    const updatePropertyURL = async () => {
        if (!selectedURLPropertyId) {
            enqueueSnackbar("Please select a property first.", { variant: 'warning' });
            return;
        }

        if (!autoGeneratedURL.trim()) {
            enqueueSnackbar("Auto generated URL is required.", { variant: 'warning' });
            return;
        }

        try {
            setUrlLoading(true);
            const response = await fetch(ConcateURL + 'UpdateURLOfTheProperty', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify({
                    PropertyId: selectedURLPropertyId,
                    AutoGeneratedURL: autoGeneratedURL,
                    ModifiedBy: UserId
                })
            });

            const result = await parseJSON(response);

            if (result?.Message === "Success" || result?.isSuccess) {
                enqueueSnackbar("Property URL updated successfully.", { variant: 'success' });
                setUrlEdit(false);
                setSelectedURLPropertyId(0);
                setAutoGeneratedURL("");
                setSelectedURLRow(null);
                getAllProperties();
                return;
            }

            enqueueSnackbar(result?.Message || "Failed to update property URL.", { variant: 'error' });
        }
        catch (error) {
            console.log(error);
            enqueueSnackbar("An error occurred while updating property URL.", { variant: 'error' });
        }
        finally {
            setUrlLoading(false);
        }
    };

    const updatePropertyMeta = async () => {
        if (!selectedMetaPropertyId) {
            enqueueSnackbar("Please select a property first.", { variant: 'warning' });
            return;
        }

        if (!metaTitle.trim() || !metaDescription.trim() || !metaKeyword.trim()) {
            enqueueSnackbar("Meta title, description, and keyword are required.", { variant: 'warning' });
            return;
        }

        try {
            setMetaLoading(true);
            const response = await fetch(ConcateURL + 'UpdateMetasofProperty', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify({
                    PropertyId: selectedMetaPropertyId,
                    MetaTitle: metaTitle.trim(),
                    MetaDescription: metaDescription.trim(),
                    MetaKeyword: metaKeyword.trim(),
                    ModifiedBy: UserId
                })
            });

            const result = await parseJSON(response);

            if (result?.Message === "Success") {
                enqueueSnackbar("Property meta updated successfully.", { variant: 'success' });
                resetMetaStates();
                getAllProperties();
                return;
            }

            enqueueSnackbar(result?.Message || "Failed to update property meta.", { variant: 'error' });
        }
        catch (error) {
            console.log(error);
            enqueueSnackbar("An error occurred while updating meta details.", { variant: 'error' });
        }
        finally {
            setMetaLoading(false);
        }
    };

    const PreviewLink = (row) => {
        if (!row.AutoGeneratedURL) {
            enqueueSnackbar("Auto generated URL is missing for this property.", { variant: 'warning' });
            return;
        }
        const previewURL = `${APIUrl.WebsiteBaseUrl}${row.AutoGeneratedURL}`;
        window.open(previewURL, '_blank'); // Open the preview URL in a new tab
    }


    const coloumn = [
        {
            name: "Sr No",
            selector: (row, index) => index + 1,
            width: "80px",
            center: true,
            cell: (row, index) => (
                <span className="font-semibold text-gray-900">{index + 1}</span>
            )
        },
        {
            name: "User Id",
            selector: (row) => row.UserName + " " + row.Email,
            width: "200px",
            cell: (row) => (
                <div className="flex flex-col gap-1 py-2">
                    <span className="font-semibold text-sm text-gray-900">{row.UserName}</span>
                    <span className="text-xs text-gray-500">{row.Email}</span>
                    <div
                        className={`mb-3 px-2 py-1 text-xs text-center font-medium rounded transition ${!row.IsActive
                            ? 'bg-red-100 text-red-800'
                            : 'bg-green-100 text-green-800'
                            }`}
                        disabled={row.IsWantFeatureProperty ? false : (row.IsFeatured && row.IsWantFeatureProperty) ?? true}
                    >
                        {row.IsActive ? "Active" : "Deleted"}
                    </div>
                </div>
            )
        },
        {
            name: "Property Id",
            selector: (row) => (
                <div className="flex flex-col gap-1">

                    <span className="font-bold text-sm text-gray-900">{row.PropertyGeneratedId} : {row.PropertyFor == "Rent" || row.PropertyFor == "PG" || row.PropertyFor == "Sell" ? "For " + row.PropertyFor : (<span className="text-xs text-orange-600">{`Property ${row.PropertyFor}`}</span>)}</span>
                    <span className="font-bold text-xs uppercase text-gray-900">{row.PropertyTypeName}</span>
                    <span className="text-xs text-gray-600">{row.BuildingTypeName} in</span>
                    <span className="text-xs text-gray-600">{row.CityName}, {row.StateName} </span>

                    <button
                        onClick={() => {
                            if (!row.IsFeatured && row.IsWantFeatureProperty) {
                                if (window.confirm('Are you sure you want to feature this property?')) {
                                    // Proceed with feature request logic
                                    fnFeatureProperty(row.PropertyId);
                                }
                            }
                        }}
                        className={`mb-3 px-2 py-1 text-xs font-medium rounded transition ${row.IsFeatured
                            ? 'bg-green-100 text-green-800 cursor-not-allowed'
                            : row.IsWantFeatureProperty && !row.IsFeatured
                                ? 'bg-yellow-100 text-yellow-800 hover:bg-yellow-200'
                                : (row.IsWantFeatureProperty && row.IsFeatured) ?? 'bg-blue-100 text-blue-800 cursor-not-allowed'
                            }`}
                        disabled={row.IsWantFeatureProperty ? false : (row.IsFeatured && row.IsWantFeatureProperty) ?? true}
                    >
                        {row.IsFeatured && row.IsWantFeatureProperty ? 'Featured' : row.IsWantFeatureProperty ? 'Make Feature' : null}
                    </button>
                </div>
            ),
            width: "180px"
        },
        {
            name: "Property Title & Detail",
            selector: (row) => (
                <div className="flex flex-col gap-2 py-2">
                    <span className="font-semibold text-sm text-gray-900 line-clamp-2">{row.PropertyTitle}</span>
                    <span className="text-xs text-gray-500">
                        Posted Date:  {row.CreatedOn ? new Date(row.CreatedOn).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : ''}
                    </span>
                    <span className="text-sm font-medium text-indigo-600">
                        {
                            row.PropertyFor == "Sell" || row.PropertyFor == "Sold" ? <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                <span>{`Expected Price: ${new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(Number(row.ExpectedPrice) || 0)} / ${row.ExpectedPricePerUnit}`}</span>
                                <span>{`Booking Amount: ${new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(Number(row.BookingAmount) || 0)}`}</span></div>

                                :
                                row.PropertyFor == "Rent" || row.PropertyFor == "Rented" || row.PropertyFor == "PG" || row.PropertyFor == "PG Rented" ? <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                    <span>{`Rent: ${new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(Number(row.RentPerMonth) || 0)} / Month`}</span>
                                    <span>{`Maintenance: ${new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(Number(row.Maintenance) || 0)}`}</span></div> : null
                        }
                    </span>
                </div>
            ),
            width: "350px",
            sortable: true
        },
        // {
        //     name: "Category",
        //     selector: (row) => (
        //         <div className="flex flex-col gap-1">
        //             <span className="font-bold text-xs uppercase text-gray-900">{row.PropertyTypeName}</span>
        //             {(row.ProjectType == 104 || row.ProjectType == 105) && (
        //                 <span className="text-xs text-gray-600">{row.ProjectTypeName}</span>
        //             )}
        //         </div>
        //     ),
        //     width: "220px",
        //     sortable: true
        // },
        {
            name: "Edit Meta Title & Description",
            cell: (row) => (
                <div className="flex flex-col gap-2">
                    {/* <span className="inline-block px-3 py-1 text-xs font-semibold rounded-full bg-blue-100 text-blue-800">
                        {row.PropertyFor}
                    </span> */}
                    <button
                        type="button"
                        onClick={() => openMetaEditor(row)}
                        className="inline-flex items-center justify-center px-3 py-2 text-xs font-semibold rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 transition"
                    >
                        Edit Meta
                    </button>

                </div>
            ),
            width: "160px",
            sortable: true
        },
        {
            name: "Edit URL & Preview",
            cell: (row) => (
                <div className="flex flex-col gap-2">

                    <button
                        type="button"
                        onClick={() => openUrlEditor(row)}
                        className={`${row.IsEditbyAdminURL ? 'bg-gray-600 hover:bg-gray-700' : 'bg-yellow-600 hover:bg-yellow-700'} inline-flex items-center justify-center px-3 py-2 text-xs font-semibold rounded-lg text-white transition`}
                        style={{ marginTop: '6px' }}
                    >
                        {row.IsEditbyAdminURL ? 'Edited by Admin' : 'Edit URL'}
                    </button>
                    <button
                        type="button"
                        onClick={() => PreviewLink(row)}
                        className="inline-flex items-center justify-center px-3 py-2 text-xs font-semibold rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 transition"
                    >
                        Preview Link
                    </button>
                </div>
            ),
            width: "160px",
            sortable: true
        },

    ];

    const PopulateSubscriptionData = async (Id) => {
        try {
            debugger;
            let items = lstProperties.filter(x => {
                return x.SubscriptionId === Id;
            });

            items.map(item => {

                setSubscriptionId(item.SubscriptionId);
                setAllowedPostCount(item.AllowedPostCount);
                setModifiedBy(UserId);

                const isLeapYear = (year) => (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
                const currentYear = new Date().getFullYear();
                const daysToAdd = isLeapYear(currentYear) ? 365 : 364;
                setSubscriptionExpiryDate(new Date(new Date().setDate(new Date().getDate() + daysToAdd)).toISOString().split('T')[0])

                setreturnId(item.SubscriptionId)
            })

            setEdit(true)

            AllowedPostCountRef.current.focus();

        }
        catch (error) {
            console.log(error);
        }
    };



    useEffect(() => {
        const result = lstProperties.filter(x => {
            return x.UserName?.toLowerCase().includes(search.toLowerCase()) ||
                x.Email?.toLowerCase().includes(search.toLowerCase()) ||
                x.PropertyGeneratedId?.toLowerCase().includes(search.toLowerCase()) ||
                x.PropertyTitle?.toLowerCase().includes(search.toLowerCase()) ||
                x.PropertyTypeName?.toLowerCase().includes(search.toLowerCase()) ||
                x.City?.toLowerCase().includes(search.toLowerCase()) ||
                x.State?.toLowerCase().includes(search.toLowerCase()) ||
                x.StatusName?.toLowerCase().includes(search.toLowerCase()) ||
                x.PropertyLabelName?.toLowerCase().includes(search.toLowerCase());
        })
        setfilterlstProperties(result);
    }, [search]);


    useEffect(() => {
        if (FilterDropdown == "pending") {
            const result = lstProperties.filter(x => x.IsWanttoUpgradeSubscription && !x.IsUpgradeSubscriptionbyAdmin);
            setfilterlstProperties(result);
        }
        else if (FilterDropdown == "approved") {
            const result = lstProperties.filter(x => x.IsWanttoUpgradeSubscription && x.IsUpgradeSubscriptionbyAdmin && x.IsActive && new Date(x.SubscriptionExpiryDate) > new Date());
            setfilterlstProperties(result);
        }
        else if (FilterDropdown == "rejected") {
            const result = lstProperties.filter(x => !x.IsWanttoUpgradeSubscription && !x.IsUpgradeSubscriptionbyAdmin && !x.IsActive);
            setfilterlstProperties(result);
        }
        else if (FilterDropdown == "expired") {
            const result = lstProperties.filter(x => x.IsWanttoUpgradeSubscription && x.IsUpgradeSubscriptionbyAdmin && x.IsActive && new Date(x.SubscriptionExpiryDate) < new Date());
            setfilterlstProperties(result);
        }
        else {
            setfilterlstProperties(lstProperties);
        }
    }, [FilterDropdown]);


    const tableData = { coloumn, filterlstProperties };


    return (
        <div>
            <Layout>
                <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
                    <div className="space-y-6">

                        <div className="bg-white rounded-xl shadow-sm border border-pink-200 p-6">
                            <div>
                                <h2 className="text-xl font-semibold text-pink-900 mb-6">Properties Overview</h2>
                            </div>
                            <div className="grid grid-cols-1 gap-6">
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
                                    <div
                                        onClick={() => setfilterlstProperties(lstProperties.filter(x => x.IsActive === false))}
                                        className="bg-gradient-to-br from-red-50 to-red-100 rounded-lg p-6 border border-red-200 cursor-pointer hover:shadow-lg transition-shadow"
                                    >
                                        <div className="flex items-center justify-between">
                                            <div>
                                                <p className="text-sm font-medium text-red-800">Deleted Properties by Vendors</p>
                                                <p className="text-3xl font-bold text-red-600 mt-2">
                                                    {lstProperties.filter(x => x.IsActive === false).length}
                                                </p>
                                            </div>
                                            <div className="text-4xl text-red-400">🚫</div>
                                        </div>
                                    </div>
                                    <div
                                        onClick={() => setfilterlstProperties(lstProperties.filter(x => x.IsFeatured === false && x.IsWantFeatureProperty == true))}
                                        className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg p-6 border border-blue-200 cursor-pointer hover:shadow-lg transition-shadow"
                                    >
                                        <div className="flex items-center justify-between">
                                            <div>
                                                <p className="text-sm font-medium text-blue-800">Vendor Requested for Featuring</p>
                                                <p className="text-3xl font-bold text-blue-600 mt-2">
                                                    {lstProperties.filter(x => x.IsFeatured === false && x.IsWantFeatureProperty == true).length}
                                                </p>
                                            </div>
                                            <div className="text-4xl text-blue-400">📋</div>
                                        </div>
                                    </div>
                                    <div
                                        onClick={() => setfilterlstProperties(lstProperties.filter(x => x.IsFeatured === true && x.IsActive == true))}
                                        className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-lg p-6 border border-purple-200 cursor-pointer hover:shadow-lg transition-shadow"
                                    >
                                        <div className="flex items-center justify-between">
                                            <div>
                                                <p className="text-sm font-medium text-purple-800">Total Featured Properties</p>
                                                <p className="text-3xl font-bold text-purple-600 mt-2">
                                                    {lstProperties.filter(x => x.IsFeatured === true && x.IsActive == true).length}
                                                </p>
                                            </div>
                                            <div className="text-4xl text-purple-400">⭐</div>
                                        </div>
                                    </div>
                                    <div
                                        onClick={() => setfilterlstProperties(lstProperties.filter(x => x.IsActive === true && x.IsPropertyImages == true))}
                                        className="bg-gradient-to-br from-green-50 to-green-100 rounded-lg p-6 border border-green-200 cursor-pointer hover:shadow-lg transition-shadow"
                                    >
                                        <div className="flex items-center justify-between">
                                            <div>
                                                <p className="text-sm font-medium text-green-800">Live Properties</p>
                                                <p className="text-3xl font-bold text-green-600 mt-2">
                                                    {lstProperties.filter(x => x.IsActive === true && x.IsPropertyImages === true && (x.PropertyFor === "Rent" || x.PropertyFor === "Sell" || x.PropertyFor === "PG")).length}
                                                </p>
                                            </div>
                                            <div className="text-4xl text-green-400">✅</div>
                                        </div>
                                    </div>
                                    <div
                                        onClick={() => setfilterlstProperties(lstProperties.filter(x => x.IsActive === true && x.IsPropertyImages == true))}
                                        className="bg-gradient-to-br from-green-50 to-green-100 rounded-lg p-6 border border-green-200 cursor-pointer hover:shadow-lg transition-shadow"
                                    >
                                        <div className="flex items-center justify-between">
                                            <div>
                                                <p className="text-sm font-medium text-green-800">Sold or Rented Properties</p>
                                                <p className="text-3xl font-bold text-green-600 mt-2">
                                                    {lstProperties.filter(x => x.IsActive === true && x.IsPropertyImages === true && (x.PropertyFor === "Sold" || x.PropertyFor === "Rented" || x.PropertyFor === "PG Rented")).length}
                                                </p>
                                            </div>
                                            <div className="text-4xl text-green-400">✅</div>
                                        </div>
                                    </div>


                                    <div
                                        onClick={() => setfilterlstProperties(lstProperties.filter(x => x.IsEditbyAdminURL === true))}
                                        className="bg-gradient-to-br from-indigo-50 to-indigo-100 rounded-lg p-6 border border-indigo-200 cursor-pointer hover:shadow-lg transition-shadow"
                                    >
                                        <div className="flex items-center justify-between">
                                            <div>
                                                <p className="text-sm font-medium text-indigo-800">URL Edit by Admin</p>
                                                <p className="text-3xl font-bold text-indigo-600 mt-2">
                                                    {lstProperties.filter(x => x.IsEditbyAdminURL === true).length}
                                                </p>
                                            </div>
                                            <div className="text-4xl text-indigo-400">✏️</div>
                                        </div>
                                    </div>

                                    <div
                                        onClick={() => setfilterlstProperties(lstProperties.filter(x => x.IsEditbyAdminURL === false))}
                                        className="bg-gradient-to-br from-yellow-50 to-yellow-100 rounded-lg p-6 border border-yellow-200 cursor-pointer hover:shadow-lg transition-shadow"
                                    >
                                        <div className="flex items-center justify-between">
                                            <div>
                                                <p className="text-sm font-medium text-yellow-800">URL Autogenerated</p>
                                                <p className="text-3xl font-bold text-yellow-600 mt-2">
                                                    {lstProperties.filter(x => x.IsEditbyAdminURL === false).length}
                                                </p>
                                            </div>
                                            <div className="text-4xl text-yellow-400">🔗</div>
                                        </div>
                                    </div>
                                    <div
                                        onClick={() => setfilterlstProperties(lstProperties)}
                                        className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-lg p-6 border border-orange-200 cursor-pointer hover:shadow-lg transition-shadow"
                                    >
                                        <div className="flex items-center justify-between">
                                            <div>
                                                <p className="text-sm font-medium text-orange-800">Total Properties</p>
                                                <p className="text-3xl font-bold text-orange-600 mt-2">
                                                    {lstProperties.length}
                                                </p>
                                            </div>
                                            <div className="text-4xl text-orange-400">🏠</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {
                            urlEdit == true && (
                                <div ref={urlEditSectionRef} className="bg-white rounded-xl shadow-sm border border-pink-200 p-6">
                                    <h2 className="text-xl font-semibold text-pink-900 mb-6">
                                        Edit Auto Generated URL
                                    </h2>
                                    <div className="grid grid-cols-1 md:grid-cols-1 gap-3">
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                            <div>
                                                <label className="block text-sm font-medium text-pink-700 mb-2">PropertyGeneratedId</label>
                                                <div className="text-sm text-gray-800 mb-2">{selectedURLRow?.PropertyGeneratedId}</div>
                                            </div>
                                            <div>
                                                <label className="block text-sm font-medium text-pink-700 mb-2">PropertyId</label>
                                                <div className="text-sm text-gray-800 mb-2">{selectedURLRow?.PropertyId}</div>
                                            </div>
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-pink-700 mb-2">PropertyTitle</label>
                                            <div className="text-sm text-gray-800 mb-2">{selectedURLRow?.PropertyTitle}</div>
                                        </div>

                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                            <div>
                                                <label className="block text-sm font-medium text-pink-700 mb-2">PropertyFor</label>
                                                <div className="text-sm text-gray-800">{selectedURLRow?.PropertyFor}</div>
                                            </div>
                                            <div>
                                                <label className="block text-sm font-medium text-pink-700 mb-2">BuildingTypeName</label>
                                                <div className="text-sm text-gray-800">{selectedURLRow?.BuildingTypeName}</div>
                                            </div>
                                        </div>

                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                            <div>
                                                <label className="block text-sm font-medium text-pink-700 mb-2">Area</label>
                                                <div className="text-sm text-gray-800">{selectedURLRow?.Area}</div>
                                            </div>
                                            <div>
                                                <label className="block text-sm font-medium text-pink-700 mb-2">CityName</label>
                                                <div className="text-sm text-gray-800">{selectedURLRow?.CityName}</div>
                                            </div>
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-pink-700 mb-2">StateName</label>
                                            <div className="text-sm text-gray-800 mb-2">{selectedURLRow?.StateName}</div>
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-pink-700 mb-2">Address</label>
                                            <div className="text-sm text-gray-800 mb-2">{selectedURLRow?.Address}</div>
                                        </div>

                                        <div>
                                            <label htmlFor="autoGeneratedURL" className="block text-sm font-medium text-pink-700 mb-2">Auto Generated URL</label>
                                            <input
                                                type="text"
                                                id="autoGeneratedURL"
                                                value={autoGeneratedURL}
                                                onChange={(e) => setAutoGeneratedURL(e.target.value)}
                                                onBlur={() => setAutoGeneratedURL(generateSlug(autoGeneratedURL))}
                                                placeholder="Enter or modify auto generated URL"
                                                className="col-12 w-full px-4 py-3 border border-pink-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                                            />
                                        </div>
                                    </div>

                                    <div className="flex flex-col sm:flex-row gap-4 mt-4">
                                        <Button
                                            type="button"
                                            onClick={updatePropertyURL}
                                            disabled={urlLoading}
                                            className="px-6 py-3 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors duration-200 flex items-center justify-center space-x-2"
                                        >
                                            <span>{urlLoading ? 'Updating...' : 'Update URL'}</span>
                                        </Button>

                                        <button
                                            type="button"
                                            onClick={() => { setUrlEdit(false); setSelectedURLRow(null); setAutoGeneratedURL(''); setSelectedURLPropertyId(0); }}
                                            className="px-6 py-3 bg-pink-600 text-white font-medium rounded-lg hover:bg-pink-700 focus:outline-none focus:ring-2 focus:ring-pink-500 focus:ring-offset-2 transition-colors duration-200"
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            )
                        }

                        {
                            metaEdit == true && (
                                <div ref={metaEditSectionRef} className="bg-white rounded-xl shadow-sm border border-pink-200 p-6">
                                    <h2 className="text-xl font-semibold text-pink-900 mb-6">
                                        Edit Property Meta Details
                                    </h2>
                                    <div className="grid grid-cols-1 md:grid-cols-1 gap-3">
                                        <div>
                                            <label htmlFor="metaTitle" className="block text-sm font-medium text-pink-700 mb-2">
                                                Meta Title
                                            </label>
                                            <input
                                                type="text"
                                                id="metaTitle"
                                                value={metaTitle}
                                                onChange={(e) => setMetaTitle(e.target.value)}
                                                placeholder="Enter meta title"
                                                className="w-full px-4 py-3 border border-pink-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                                            />
                                        </div>

                                        <div>
                                            <label htmlFor="metaDescription" className="block text-sm font-medium text-pink-700 mb-2">
                                                Meta Description
                                            </label>
                                            <textarea
                                                id="metaDescription"
                                                rows={4}
                                                value={metaDescription}
                                                onChange={(e) => setMetaDescription(e.target.value)}
                                                placeholder="Enter meta description"
                                                className="w-full px-4 py-3 border border-pink-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                                            />
                                        </div>

                                        <div>
                                            <label htmlFor="metaKeyword" className="block text-sm font-medium text-pink-700 mb-2">
                                                Meta Keyword
                                            </label>
                                            <textarea
                                                id="metaKeyword"
                                                rows={4}
                                                value={metaKeyword}
                                                onChange={(e) => setMetaKeyword(e.target.value)}
                                                placeholder="Enter meta keywords"
                                                className="w-full px-4 py-3 border border-pink-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                                            />
                                        </div>
                                    </div>

                                    <div className="flex flex-col sm:flex-row gap-4 mt-4">
                                        <Button
                                            type="button"
                                            onClick={updatePropertyMeta}
                                            disabled={metaLoading}
                                            className="px-6 py-3 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors duration-200 flex items-center justify-center space-x-2"
                                        >
                                            <span>{metaLoading ? 'Updating...' : 'Update Meta'}</span>
                                        </Button>

                                        <button
                                            type="button"
                                            onClick={() => resetMetaStates()}
                                            className="px-6 py-3 bg-pink-600 text-white font-medium rounded-lg hover:bg-pink-700 focus:outline-none focus:ring-2 focus:ring-pink-500 focus:ring-offset-2 transition-colors duration-200"
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            )
                        }

                        {
                            edit == true && (
                                <div className="bg-white rounded-xl shadow-sm border border-pink-200 p-6">
                                    <h2 className="text-xl font-semibold text-pink-900 mb-6">
                                        Manage Subscription Requests
                                    </h2>
                                    <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                                        <div>
                                            <label htmlFor="name" className="block text-sm font-medium text-pink-700 mb-2">
                                                Post Credits
                                            </label>
                                            <input
                                                type="text"
                                                id="name"
                                                ref={AllowedPostCountRef}
                                                value={AllowedPostCount}
                                                onChange={(e) => { setAllowedPostCount(e.target.value) }}
                                                placeholder="Enter Post Credits"
                                                className="w-full px-4 py-3 border border-pink-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                                            />
                                        </div>
                                        <div>
                                            <label htmlFor="name" className="block text-sm font-medium text-pink-700 mb-2">
                                                Subscription Expiry Date
                                            </label>
                                            <input
                                                type="date"
                                                id="name"
                                                disabled={true}
                                                ref={SubscriptionExpiryDateRef}
                                                value={SubscriptionExpiryDate}
                                                onChange={(e) => { setSubscriptionExpiryDate(e.target.value) }}
                                                placeholder="Enter Subscription Expiry Date"
                                                className="w-full px-4 py-3 border border-pink-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                                            />
                                        </div>
                                    </div>

                                    <div className="flex flex-col sm:flex-row gap-4 mt-3">
                                        {
                                            edit == true ?
                                                <Button
                                                    className="px-6 py-3 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors duration-200 flex items-center justify-center space-x-2"

                                                >
                                                    <span>Update</span>
                                                </Button> : null
                                        }

                                        <button
                                            type="button"
                                            onClick={() => doEmptyStates()}
                                            className="px-6 py-3 bg-pink-600 text-white font-medium rounded-lg hover:bg-pink-700 focus:outline-none focus:ring-2 focus:ring-pink-500 focus:ring-offset-2 transition-colors duration-200"
                                        >
                                            Reset
                                        </button>
                                    </div>
                                </div>
                            )
                        }

                        <div className="bg-white rounded-xl shadow-sm border border-pink-200 overflow-hidden">
                            <div className="overflow-x-auto">
                                <DataTable
                                    title="All Properties Data"
                                    columns={coloumn}
                                    data={filterlstProperties}
                                    pagination
                                    fixedHeader
                                    fixedHeaderScrollHeight="550px"
                                    selectableRows
                                    selectableRowsHighlight
                                    highlightOnHover
                                    subHeader
                                    subHeaderAlign="right"
                                    subHeaderComponent={
                                        <>
                                            <input type="text"
                                                placeholder="search..."
                                                className="w-full sm:w-64 px-4 py-2 border border-pink-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                                value={search}
                                                onChange={(e) => setsearch(e.target.value)}
                                            />
                                        </>
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </main>
            </Layout >
        </div >
    )
}

export default ManageAllProperties